import React from 'react';

import {IEditorialModule2} from './IEditorialModule2';

import styles from './EditorialModule2.module.scss';

const EditorialModule2 = ({body}: IEditorialModule2) => {
	return (
		<>
			{body.length > 1 && (
				<div className={styles['module-editorial__module__2']}>
					<div className={styles['module-editorial__module__2--group']}>{body[0]}</div>
					<div className={styles['module-editorial__module__2--group']}>{body[1]}</div>
				</div>
			)}
		</>
	);
};

export default EditorialModule2;
